export class ControllerApiPath {
  public static readonly inviteUser = 'account/inviteuser';
  public static readonly acceptInvite = 'identity/acceptinvite?key=';
  public static readonly updatePassword = 'identity/updatepassword/';
  public static readonly login = 'account/login';
  public static readonly checkEmailId = 'account/CheckEmailId';
  public static readonly identity = 'identity';
  public static readonly members = 'members';
  public static readonly memberMealPlan = 'memberMealPlan';
  public static readonly teams = 'teams';
  public static readonly foodlog = 'foodLogs';
  public static readonly member = 'member';
  public static readonly scores = 'scores';
  public static readonly events = 'events';
  public static readonly getUserById = 'account/GetUserById';
  public static readonly labs = 'LabWork';
  public static readonly vital = 'vitals';
  public static readonly healthData = 'healthData';
  public static readonly preferences = 'preferences';
  public static readonly mealPlan = 'mealPlan';
  public static readonly draftMealPlan = 'mealPlan/draftMealPlan';
  public static readonly futureMealPlan = 'mealPlan/future';
  public static readonly updateDraftMealPlanRecipes = 'mealPlan/updateRecipes';
  public static readonly assignMealPlan = 'mealPlan/assignMealPlan';
  public static readonly user = 'users';
  public static readonly deleteUser = 'users/delete';
  public static readonly getUserDetailsById = 'users/getbyid';
  public static readonly updateUserDetails = 'users/update';
  public static readonly fitnessPlan = 'fitnessplan';
  public static readonly fitnessPlanTemplates = 'fitness-plan-templates';
  public static readonly memberdata = 'MemberDataUpload';
  public static readonly recipe = 'recipes';
  public static readonly ingredient = 'ingredients';
  public static readonly allergy = 'allergies';
  public static readonly diet = 'diets';
  public static readonly mealInsights = 'mealInsights';
  public static readonly hydrationGoals = 'hydration-goals';
  public static readonly hydrationLogs = 'hydration-logs';
}

export class StatesConstant {
  public static readonly userState = 'userState';
}
